import { message } from "ant-design-vue";
import api from "./api";
import { GetAkData } from "@/views/moving_function/views/shipping_preview_list/bos_config";
import imgUtil from "@/views/moving_function/utils/img";
import { getCreateTemplateParams } from "./options";
import { COU_fristStrToLowerCase } from "@/utils/co_util";

// 标题/sku替换关键字数据集合
const replaceArr = [
  {
    key: "keywordReplaceArr",
    waitReplace: "keywordWaitReplace",
    replace: "keywordReplace",
    title: "标题",
  },
  {
    key: "skuKeywordReplaceArr",
    waitReplace: "skuKeywordWaitReplace",
    replace: "skuKeywordReplace",
    title: "SKU",
  },
];
// 如果有改变原图，则需要上传到百度云再铺货
async function getSingleFinalImageUrl(obj) {
  let file = await imgUtil.Base64ToFile(obj.img);
  // 如果没有file 说明转换的时候出了问题, 那就跳过这张图片

  obj.trueImg = await api.UploadImage2(file);

  return obj;
}
// 新增 / 编辑 商品模板
const CreateOrEditGoodsTemplate = async (This) => {
  // --------- 上传到百度云前验证开始 ---------
  const result1 = await GetAkData();
  if (!result1?.success) {
    This.$message.warning(result1?.msg);
    return (This.loading = false);
  }
  let str = `${This.getOperateType}商品模板`;
  const params = This.params;
  if (!params.name) return This.$message.warning(`${str}，模板名称是必填项`);
  if (params.setCatType === 2 && !params.category?.length)
    return This.$message.warning("手动指定类目，类目是必选项");
  if (params.setCatType !== 2) {
    params.catIds = null;
    params.category = null;
  }
  // 统一设置库存为
  if (!params.defaultStock && params.stockModifyType === 0)
    return This.$message.warning(`${str}，统一库存是必填项`);
  if (!params.freightId && params.freightId !== 0)
    return This.$message.warning(`${str}，运费模板是必选项`);
  if (params.freightId && This.freightTemplateRuleType !== 2 && !params.weight)
    return This.$message.warning("已选择的运费模板，商品重量是必填项");
  // 0 立即上架、1 放入仓库、2 放入草稿箱
  const isCommit = params.isCommit;
  // 说明是1组替换都没填写, 不需要判断
  for (let option of replaceArr) {
    if (
      params[option.key].length === 1 &&
      !params[option.key][0].oldValue &&
      !params[option.key][0].newValue
    )
      params[option.waitReplace] = params[option.replace] = "";
    else {
      for (let option2 of params[option.key]) {
        if (!option2.oldValue || !option2.newValue)
          return This.$message.warning(
            `${option.title}【替换关键字】、【替换为】必须填写`
          );
      }
      params[option.waitReplace] = params[option.key]
        .map((item) => item.oldValue.trim())
        .join(",");
      params[option.replace] = params[option.key]
        .map((item) => item.newValue.trim())
        .join(",");
    }
  }
  // 启用SKU低价引流方式的话要检查是否已填写对应的文本框
  let firstPriceRatio = params.firstPriceRatio;
  if (params.sku_low_price_status) {
    if (!params.skuNumLow)
      return This.$message.warning("启用SKU低价引流方式，SKU数量大于是必填项");
    if (!params.firstSkuStock)
      return This.$message.warning(
        "启用SKU低价引流方式，设置第一个SKU库存是必填项"
      );
    if (!firstPriceRatio) firstPriceRatio = 1;
  }
  // 倍数，默认传1
  let priceRatio = params.priceRatio;
  if (!priceRatio) priceRatio = 1;
  const titleDeleteKeyword = params.keywordDel.trim().replaceAll("，", ",");
  const skuDeletekeyword = params.skuKeywordDel.trim().replaceAll("，", ",");
  This.loading = true;
  if (params["descImgAddPreIsUpdate"]) {
    const imgObj = await getSingleFinalImageUrl({
      img: params["descImgAddPre"],
    });
    params["descImgAddPre"] = imgObj.trueImg;
    params["descImgAddPreIsUpdate"] = false;
  }
  if (params["descImgAddSufIsUpdate"]) {
    const imgObj = await getSingleFinalImageUrl({
      img: params["descImgAddSuf"],
    });
    params["descImgAddSuf"] = imgObj.trueImg;
    params["descImgAddSufIsUpdate"] = false;
  }

  const obj = {
    templateId: params.id || 0,
    name: params.name.trim(),
    catIds: params.category,
    standardBrandName: params.standardBrandName,
    standardBrandId: params.standardBrandId,
    addMoney: params.addMoney || 0,
    defaultStock: params.defaultStock,
    freightId: params.freight_id === 0 ? "0" : params.freightId,
    supply7dayReturn: params.supply7dayReturn,
    isCommit,
    priceRatio,
    isRepeat: params.isRepeat,
    weight: params.weight,
    weightUnit: params.weightUnit,
    descImgAddPre: params.descImgAddPre,
    descImgAddSuf: params.descImgAddSuf,
    descImgDeletePre: params.descImgDeletePre,
    descImgDeleteSuf: params.descImgDeleteSuf,
    ttPriceType: params.ttPriceType,
    alPriceType: params.alPriceType, // 平台价格类型 1
    skuLowPriceStatus: params.skuLowPriceStatus,
    skuNumLow: params.skuNumLow,
    firstSkuStock: params.firstSkuStock,
    firstPriceRatio,
    firstAddMoney: params.firstAddMoney || 0,
    setCatType: params.setCatType,
    autoMatchBrand: params.autoMatchBrand,
    titlePrefix: params.titlePrefix.trim(),
    titleSuffix: params.titleSuffix.trim(),
    keywordDel: titleDeleteKeyword,
    titleMoreSixtyDeleteType: params.titleMoreSixtyDeleteType,
    keywordWaitReplace: params.keywordWaitReplace,
    keywordReplace: params.keywordReplace,
    skuKeywordDel: skuDeletekeyword,
    skuKeywordWaitReplace: params.skuKeywordWaitReplace,
    skuKeywordReplace: params.skuKeywordReplace,
    setDecimal: params.setDecimal,
    isSecondHand: params.isSecondHand,
    isFolt: params.isFolt,
    marketPriceRatio: params.marketPriceRatio,
    // ...This.$refs.prohibitedWordFiltering?.getParams(), // 违禁词
    // ...This.$refs.jumpSetup.getParams() // 跳过的配置
  };
  // 现货模式
  if (params.presellType === 0) obj.deliveryDelayDay = params.deliveryDelayDay;
  // 统一设置库存为
  if (params.stockModifyType === 0) obj.defaultStock = params.defaultStock;
  // 根据上游库存设置
  else if (params.stockModifyType === 1) {
    obj.stockCalcType = params.stockCalcType;
    obj.stockModifyNum = params.stockModifyNum;
  }
  obj.stockModifyType = params.stockModifyType;
  let { msg, success, result } = await editOrAddByTemplateId(obj);
  if (success) {
    This.visible = false;
    // 新增模板并且勾选了设置为默认模板时
    if (!params.id && params.setDefaultAndUse) {
      const defaultResult = await api.SetDefaultTemplate(result.Id);
      const s = "，设置为默认模板";
      if (defaultResult.success) {
        str += `${s}成功`;
        This.goodsTemplateId = result.Id;
      } else str += `${s}失败，原因：${defaultResult.msg}`;
    }
    This.$message.success(`${str}成功`);
    await This.getGoodsTemplateList();
  } else {
    This.$message.warning(`${str}失败，原因:【${msg || ""}】`);
    if (msg?.includes("未找到")) {
      This.visible = false;
      This.currentGoodsTemplate = {};
      This.params.id = This.goodsTemplateId = null;
    }
  }
  This.loading = false;
};

async function editOrAddByTemplateId(obj) {
  let info = {};
  // 编辑
  if (obj.templateId) info = await api.EditGoodsTemplate(obj);
  // 添加
  else info = await api.AddGoodsTemplate(obj);
  const { msg, success, result } = info;
  return { msg, success, result };
}

// 获取商品模板列表
async function GetGoodsTemplate(val, getDefaultTemplate) {
  const { list, success } = await api.GetGoodsTemplateList({
    page: 1,
    size: 60,
    name: val || "",
    getDefaultTemplate,
  });
  if (success && list?.length) {
    list.map((item) => {
      item.label = `${item.Name}${item.IsDefault ? " 【默认模板】" : ""}`;
      item.value = item.Id;
    });
  }
  return list;
}

// 获取运费模板列表
async function GetFreightTemplate() {
  const { list, msg, success } = await api.GetFreightTemplateList();
  if (!success) message.warn(`获取运费模板失败，原因:【${msg}】`, 2.3);
  return list;
}

// 显示商品模板弹出框
async function EditGoodsTemplate(This) {
  let current = {};
  // 编辑需要获取模板详情
  let { templateInfo, msg, success } = await api.GetGoodsTemplateDetail(
    This.goodsTemplateId
  );
  if (!success) return This.$message.warn(msg);
  // 全部转成小写开头
  for (var key in templateInfo) {
    const newKey = COU_fristStrToLowerCase(key);
    current[newKey] = templateInfo[key];
  }
  for (let obj of replaceArr) {
    current[obj.key] = [];
    if (current[obj.waitReplace] && current[obj.replace]) {
      const arr1 = current[obj.waitReplace].split(",");
      const arr2 = current[obj.replace].split(",");
      for (let i in arr1) {
        current[obj.key].push({ oldValue: arr1[i], newValue: arr2[i] });
      }
    } else current[obj.key] = [{ oldValue: "", newValue: "" }];
  }
  This.imgFile = {
    descImgAddPre: { img: current.descImgAddPre },
    descImgAddSuf: { img: current.descImgAddSuf },
  };
  This.visible = true;
  // 如果不是添加,获取模板详情
  This.$nextTick(() => {
    const params = This.$refs.jumpSetup?.params || {};
    This.params = {
      ...params,
      ...current,
    };
    This.params.category = current.catIds || null;
    // 设置跳过配置参数
    This.$refs.jumpSetup?.setParams(This.params);
    // 设置违禁词过滤参数
    // const el = This.$refs.prohibitedWordFiltering
    // const bool = current.startProhibitedWordReplace ? true : false
    // // 只有编辑模板时才判断是否已选
    // el.setParams({
    //   startProhibitedWordReplace: bool,
    //   useMarketProhibitedWord: bool
    // })
    // el.getWords()
  });
}

function AddGoodsTemplate(This) {
  This.visible = true;
  // 如果不是添加,获取模板详情
  This.$nextTick(() => {
    This.params = getCreateTemplateParams();
    // 设置跳过配置参数
    This.$refs.jumpSetup?.setParams(This.params);
  });
}

// 设置为默认模板
async function SetDefault(This) {
  const { success, msg } = await api.SetDefaultTemplate(This.params.id);
  if (!success) return This.$message.warning(msg || "设置默认商品模板失败");
  This.$message.success("设置为默认商品模板成功");
  This.params.is_default = success;
  This.visible = false;
  This.getGoodsTemplateList();
}

// 删除商品模板
async function DeleteTemplate(This, item) {
  const { label, Id } = item;
  const { success, msg } = await api.DeleteGoodsTemplate(Id);
  if (!success) return This.$message.warning(msg);
  This.$message.success(`删除模板【${label}】成功`);
  This.goodsTemplateList.splice(
    This.goodsTemplateList.findIndex((temp) => temp.Id === Id),
    1
  );
  if (This.goodsTemplateId === Id)
    This.goodsTemplateId = This.goodsTemplateList?.[0]?.Id || null;
}

export default {
  CreateOrEditGoodsTemplate,
  GetGoodsTemplate,
  GetFreightTemplate,
  EditGoodsTemplate,
  AddGoodsTemplate,
  SetDefault,
  DeleteTemplate,
};
